exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.letrasTitulo{\r\n\r\n\tfont-size:8vw;\r\n\tfont-weight: bold;\r\n\r\n\r\n\r\n}\r\n\r\n.letray {\r\n\tfont-size:4vw;\r\n\tcolor: #337ab7;\r\n}\r\n\r\n.lema {\r\n\r\n\tfont-family:\"Monotype Corsiva\";\r\n\tfont-size:2vw;\t\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/contacto/contacto.component.css
// module id = ../../../../../src/app/contacto/contacto.component.css
// module chunks = main